export default "__VITE_ASSET__CR1oL855__"